<template>
    <div>
        <div class="w" id="content">
            <div class="s_tl">
                当前位置：<a href="/">首页</a>
                <em class="lr3">&#62;</em>
                <a href="/help">帮助中心</a>
                <em class="lr3">&#62;</em>
                <a href="">新手上路</a>
                <em class="lr3">&#62;</em>
                <a href="">CEO邮箱</a>
            </div>
            <div class="ubg">
                <left-side></left-side>
                <!--left over-->
                <div class="u_r">
                    <div class="ah1 alC yahei">
                        <h1 class="f18">CEO邮箱</h1>
                        <p class="c9">发布时间：2022-01-04</p>
                    </div>
                    <div class="ainfo ov yahei">
                        <p>
                            <img width="881" height="409" src="https://s.cccgx.com/images/article/20190909/1568018857298889.jpg">
                        </p>
                        <p><br></p>
                        <h3>Dear Customers and Partners,</h3>
                        <p>
                            In order to both address appreciation for your support and trust and strengthen mutual contact and cooperation, we have opened the Qu CEO mailbox as the direct window for communication.
                        </p>
                        <p>
                            When you meet any problem during the purchasing or cooperating or have any suggestions and feedback for the developing of Qu, report back to us through this email address.
                        </p>
                        <p>
                            <span>
                                Email address：
                                <a href="mailto:ceo@hongju.cc" style="text-decoration: underline;">
                                    <span>ceo@hongju.cc</span>
                                </a>
                            </span>
                        </p>
                        <p>
                            Thank you for your support and cooperation as always!
                        </p>
                        <p>
                            <strong>尊敬的夜樱情趣用户、合作伙伴：</strong>
                        </p>
                        <p>
                            <span>
                                为了感谢大家一直对夜樱情趣的支持与信任，加强夜樱情趣与和您之间的密切交流与合作，我们开通了夜樱情趣CEO邮箱作为与大家沟通交流的直接窗口。
                                <br> 当您在夜樱情趣的交易、合作过程中遇到任何问题，或您对夜樱情趣的发展有更多建议和反馈,请通过该邮箱联系我们！
                                <!-- <br> 邮箱地址： -->
                            </span>
                            <!-- <a href="file:///C:/Users/Administrator/Desktop/%E5%BE%88%E5%A4%9A%E5%86%85%E5%AE%B9/CEO%E9%82%AE%E7%AE%B1/ceo@hongju.cc" >
                                <span>ceo@hongju.cc</span>
                            </a> -->
                            <br>
                            <span>感谢您一如既往的支持和配合！</span>
                        </p>
                        <p><br></p>
                    </div>
                    <!--info over-->
                    <p class="lh30"></p>
                    <p class="bline" style="padding: 30px 0px 0 0;"></p>
                    <p class="lh30"></p>
                    <p style="font-size:16px;">
                        <a href="/help/zhengpinbaozheng" style="float:left;">上一篇:正品保证</a>
                        <a href="/help/yinsizhengce" class="pl10" style="float:right">下一篇:隐私权政策</a>
                    </p>
                </div>
                <!--right over-->
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Left_side from "@/components/help/left-side"
export default {
    components:{
        'left-side': Left_side
    },
}
</script>

<style scoped>
.ainfo {line-height: 32px;padding-top: 10px;font-size: 14px;}
.font16{font-size: 16px;}
.ubg{border:1px solid #e5e5e5;background-color:#fff;overflow:hidden;}
.u_l{width:170px;padding:10px;background:#fff;border-right:1px solid #e5e5e5;}
.u_r{padding:10px 40px 30px 40px;border-left:1px solid #e5e5e5;line-height:25px;background:#fff;margin-left:190px;min-height:600px;}
.dsl{display:inline;font-weight:normal;}
.udl{margin:0 5px 15px 5px;}
.udl dt{border-bottom:1px solid #e5e5e5;line-height:40px;display:block;font-size:14px;color:#333;font-weight:bold;margin-bottom:10px;}
.udl dd{line-height:30px;text-indent:15px;}
.udl a{display:block;color:#777;margin-bottom:1px;}
.udl a:hover,.udl a.on{color:#c40000;text-decoration:none; background-color:#e5e1e1;}
.article{width:100%;}
.article li{border-bottom:1px dashed #ddd;display:block;width:100%;font-size:14px;line-height:45px;}
.article a{display:block;width:100%;overflow:hidden;}
.article a:hover{color:#c40000;}
.ah1{color:#333;line-height:30px;padding-bottom:10px;border-bottom:2px solid #ddd;}
.a_goods a{width:220px;height:280px;display:inline;float:left;margin:10px 6px;line-height:18px;white-space:nowrap;overflow:hidden;}
</style>


// WEBPACK FOOTER //
// src/components/help/ceomail.vue